(function () {
  const COPY_LABEL = 'Copier';
  const COPIED_LABEL = 'Copié';

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-lgk-promo-code-copy]');
    if (!button) return;

    const wrap = button.closest('[data-lgk-promo-code]');
    const valueEl = wrap && wrap.querySelector('[data-lgk-promo-code-value]');
    const code = valueEl && valueEl.textContent ? valueEl.textContent.trim() : '';

    if (!code) return;

    copyText(code)
      .then(function () {
        wrap.classList.add('is-copied');
        button.setAttribute('aria-label', 'Code ' + code + ' copié');

        const label = button.querySelector('[data-lgk-promo-code-label]');
        if (label) label.textContent = COPIED_LABEL;

        const popup = button.closest('newsletter-popup');
        if (popup && typeof popup.hide === 'function') {
          window.setTimeout(function () {
            popup.hide();
          }, 600);
          return;
        }

        window.setTimeout(function () {
          wrap.classList.remove('is-copied');
          button.setAttribute('aria-label', 'Copier le code ' + code);
          if (label) label.textContent = COPY_LABEL;
        }, 2000);
      })
      .catch(function () {
        button.setAttribute('aria-label', 'Impossible de copier le code');
      });
  });
})();
